import React, { forwardRef } from "react";
import { chakra, Icon, useMultiStyleConfig, } from "@chakra-ui/react";
import { SelectorIcon } from "./icons";
export const ComboboxToggleButton = forwardRef((props, ref) => {
    const styles = useMultiStyleConfig("Combobox");
    return (React.createElement(chakra.button, { ref: ref, __css: styles["toggleButton"], type: "button", ...props },
        React.createElement(Icon, { as: SelectorIcon, __css: styles["toggleButtonIcon"], color: "text.secondary" })));
});
